import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import { isMetal } from "../../../../../service/oneClickIs"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./longHole.png"
import imgMetal from "./longHole_metal.png"

const 長穴 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { longHole: shouldShow } = getDisplayCondition(values)

  const legend = isMetal(values) ? "長穴/くりぬき加工/\nφ6.35mm以上の\n丸穴" : "長穴"
  const src = isMetal(values) ? imgMetal : img

  return (
    <OneClickField isShow={shouldShow} legend={legend} helpURL={HELP_LINKS.長穴} src={src}>
      <RadioGroup name={FIELD_NAMES.長穴} selectedValue={values.longHole} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.長穴.あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT.長穴.なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.longHole} />
    </OneClickField>
  )
}

export default 長穴
